import React from "react";
import AppIcons from "../../utils/AppIcons";
import StringUtil from "../../utils/StringUtil";

interface ISearchFilterTagProps {
  label: string | undefined;
  filterType: string;
  filterValue: number | string;
  onDismiss: (filterType: string, filterValue: string | number) => void;
}

function SearchFilterTag({
  label,
  filterType,
  filterValue,
  onDismiss,
}: ISearchFilterTagProps) {
  //if (label) {
  return (
    <div className="search-filter-tag">
      {StringUtil.capitalizeFirstLetter(label!)}
      <a onClick={() => onDismiss(filterType, filterValue)}>{AppIcons.CLOSE}</a>
    </div>
  );
  //}
  return null;
}

export default SearchFilterTag;
